const regexOptions = {
  phone: /^[0-9]{8,12}$/,
  email: /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/m,
}

export const validate = (value, type) => {
  const validator = new RegExp(regexOptions[type])
  return validator.test(value)
}
